import { render, staticRenderFns } from "./MediaVideo.vue?vue&type=template&id=2f321257&scoped=true"
import script from "./MediaVideo.vue?vue&type=script&lang=js"
export * from "./MediaVideo.vue?vue&type=script&lang=js"
import style0 from "./MediaVideo.vue?vue&type=style&index=0&id=2f321257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f321257",
  null
  
)

export default component.exports